import { useEffect, useState } from 'react';
//
import { MENU } from '../copy';

// ----------------------------------------------------------------------

const SECTION_IDS = MENU.primary
  .map(({ section }) => section)
  .filter((id): id is string => Boolean(id));

export default function useActiveSection(enabled: boolean) {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach(({ isIntersecting, target }) =>
          setActive((current) => {
            if (isIntersecting) {
              return target.id;
            }
            return current === target.id ? null : current;
          })
        ),
      { rootMargin: '-45% 0px -50% 0px' }
    );

    SECTION_IDS.forEach((id) => {
      const section = document.getElementById(id);
      if (section) {
        observer.observe(section);
      }
    });

    return () => observer.disconnect();
  }, [enabled]);

  return active;
}
